/**
 * @fileoverview O can() das telas: com a regra nova ligada na empresa, a
 * permissão do catálogo (a mesma que a API confere); sem ela, a regra de hoje
 * daquele ponto da tela, que quem chama passa, como o can(req, chave,
 * permitidoAntes) do backend. Assim, sem a regra ligada, nada muda na tela.
 */

import { useCallback } from "react";
import usePermissionStore from "../../stores/usePermissionStore";

const allowed = (state, key, allowedBefore) =>
  state.mode === "enforce" ? state.granted.includes(key) : !!allowedBefore;

const usePermission = () => {
  const mode = usePermissionStore((state) => state.mode);
  const granted = usePermissionStore((state) => state.granted);
  const loaded = usePermissionStore((state) => state.loaded);
  // O nível das conversas que a API calculou (own, queues, company ou none), com a regra nova ligada.
  const ticketsView = usePermissionStore((state) => state.ticketsView);
  // Vê os números de algum departamento (em qualquer modo).
  const hasDepartments = usePermissionStore((state) => state.departments);
  const can = useCallback((key, allowedBefore) => allowed({ mode, granted }, key, allowedBefore), [mode, granted]);
  return { can, enforce: mode === "enforce", loaded, ticketsView, hasDepartments };
};

// Fora do React (montagem de listas, rotas): a mesma regra, com o acesso de agora.
export const canNow = (key, allowedBefore) => allowed(usePermissionStore.getState(), key, allowedBefore);

// A regra de hoje de "admin" na API (o isAdminUser de legacyRules.ts): o perfil
// admin ou o super. É o "permitido antes" das ações que hoje são do admin.
export const isAdminUser = (user) => user?.profile === "admin" || !!user?.super;

export default usePermission;
